import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ImageCarousel from '../../../components/stateful/ImageCarousel';
import { FLIPPER_VOYAGER_MEDIA_GALLERY } from '../../../../constants/flippers';
import useFlipper from '../../../../modules/react/hooks/useFlipper';
import styles from './styles.scss';

const propTypes = {
  autoplay: PropTypes.bool,
  bannerText: PropTypes.string,
  facility: PropTypes.shape({
    name: PropTypes.string,
  }),
  images: PropTypes.arrayOf(PropTypes.shape({
    file: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
  })),
  showBanner: PropTypes.bool,
  className: PropTypes.string,
  isBuilderView: PropTypes.bool,
};

const defaultProps = {
  autoplay: false,
  bannerText: '',
  showBanner: false,
  className: styles.defaultSizing,
  images: [],
  facility: undefined,
  isBuilderView: false,
};

const FacilityImageSlideShow = ({
  facility,
  images,
  autoplay,
  bannerText,
  showBanner,
  className,
  isBuilderView,
}) => {
  const mediaGalleryEnabled = useFlipper(FLIPPER_VOYAGER_MEDIA_GALLERY);

  if (!facility) {
    return false;
  }

  if ((!images || !images.length) && isBuilderView) {
    return <span>No images set.</span>;
  }
  return (
    <>
      <div className={cx(styles.carousel, className)}>
        <ImageCarousel
          mediaGalleryEnabled={mediaGalleryEnabled}
          images={images}
          autoplay={autoplay}
          bannerText={bannerText}
          showBanner={showBanner}
        />
      </div>
    </>
  );
};

FacilityImageSlideShow.propTypes = propTypes;
FacilityImageSlideShow.defaultProps = defaultProps;

export default FacilityImageSlideShow;
